import { SportsbookThirdpartyContainer, SportsbookThirdpartyGuard } from "@obg/mat.ui.gaming";
import { ProductType } from "@obg/ngx.core";
import { RouteConfig } from "@obg/ngx.router";

import { CoreLayoutContainer } from "../core/layouts/core-layout/core-layout.container";

const DEFAULT_SPORTSBOOKTHIRDPARTY_ROUTE = {
	component: SportsbookThirdpartyContainer,
	layout: CoreLayoutContainer,
	canActivate: [SportsbookThirdpartyGuard],
	data: {
		product: ProductType.SportsbookThirdparty,
		hideBreadcrumb: true,
		showSeoFooter: true,
	},
};

export const SPORTSBOOKTHIRDPARTY_ROUTES_CONFIG: RouteConfig[] = [
	{
		name: "sportsbook-thirdparty",
		path: "",
		...DEFAULT_SPORTSBOOKTHIRDPARTY_ROUTE,
	},

	{
		name: "sportsbook-thirdparty.destination",
		path: ":destination",
		...DEFAULT_SPORTSBOOKTHIRDPARTY_ROUTE,
	},

	{
		name: "sportsbook-thirdparty.event",
		path: ":sport/:event",
		...DEFAULT_SPORTSBOOKTHIRDPARTY_ROUTE,
	},

	{
		name: "sportsbook-thirdparty.subevent",
		path: ":sport/:event/:subevent",
		...DEFAULT_SPORTSBOOKTHIRDPARTY_ROUTE,
	},
];

export const SPORTSBOOKTHIRDPARTY_LIVE_ROUTES_CONFIG: RouteConfig[] = [
	{
		name: "sportsbook-thirdparty-live",
		path: "",
		...DEFAULT_SPORTSBOOKTHIRDPARTY_ROUTE,
	},

	{
		name: "sportsbook-thirdparty-live.event",
		path: ":sport/:event",
		...DEFAULT_SPORTSBOOKTHIRDPARTY_ROUTE,
	},
];
